import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import {
  Button,
  Icon,
  Label,
  Modal,
  Dropdown,
  Popup,
  Menu,
} from "semantic-ui-react";
import {
  handleAttenders,
  handleStatus,
} from "../../store/actions/athleteActions";
import { connect } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import VisitorList from "./VisitorList";
import AddVisitor from "./AddVisitor";
import "../../pages/EventInfo.css";

export const placeHolderImage =
  "https://upload.wikimedia.org/wikipedia/commons/9/99/Sample_User_Icon.png";

const EventCard = (props) => {
  const [showListAdd, setListAdd] = useState(true);
  const [visitor, setVisitor] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [advocate, showAdvocate] = useState(false);
  const [newVisitors, setNewVisitors] = useState([]);
  const [defaultView, setDefault] = useState(true);
  const [list, setList] = useState(false);

  const dispatch = useDispatch();
  const handleApproval = (data, id) => {
    dispatch(handleStatus(id, data));
  };
  const handleAttend = () => {
    const attenders = [...props.visitors];
    if (!attenders.includes(props.loggedUser)) {
      attenders.push(props.loggedUser);
    } else if (attenders.includes(props.loggedUser)) {
      for (let i = 0; i < attenders.length; i++) {
        if (attenders[i] === props.loggedUser) {
          attenders.splice(i, 1);
          i--;
        }
      }
    }
    dispatch(handleAttenders(props.id, attenders));
  };
  useEffect(() => {
    if (props.visitors) {
      if (props.visitors.includes(props.loggedUser)) {
        setVisitor(true);
      } else setVisitor(false);
    }
  }, [props.visitors, props.loggedUser]);
  const handleRemoveVisitor = (visitor) => {
    const attenders = [...props.visitors];
    if (attenders.includes(visitor)) {
      for (let i = 0; i < attenders.length; i++) {
        if (attenders[i] === visitor) {
          attenders.splice(i, 1);
          i--;
        }
      }
    }
    dispatch(handleAttenders(props.id, attenders));
  };
  return (
    <>
      <div
        key={props.id}
        className={
          !props.eyShow
            ? "eventDetails-data"
            : "eventDetails-data event-page-card"
        }
      >
        {props.url ? (
          <a
            className="eventTitle custom-title"
            href={props.url}
            target="blank"
          >
            {props.name}
          </a>
        ) : (
          <h5 className="custom-title">{props.name}</h5>
        )}
        <div className="datas">
          <p>{props.endDate !== props.startDate ? "Start" : "Event"} Date: </p>
          <span>{props.startDate}</span>
        </div>
        {props.endDate !== props.startDate && (
          <div className="datas">
            <p>End Date:</p>
            <span>{props.endDate ? props.endDate : "One Day Event"}</span>
          </div>
        )}
        {props.advocate && (
          <div className="datas">
            <p>Advocate:</p>
            <span>{props.advocateName}</span>
          </div>
        )}

        {props.location && (
          <div className="datas">
            <p>Location:</p>
            <span>{props.location}</span>
          </div>
        )}
        <div className="datas">
          <p>Sport:</p>
          <span>{props.sport}</span>
        </div>
        <div
          className={
            !props.eyShow ? "datas align-center" : "datas align-center mb-0"
          }
        >
          <p>Attendants:</p>
          <span>
            <Label color="teal" onClick={() => setOpen(true)}>
              {props.attendant && props.attendant.length}
            </Label>
          </span>
        </div>

        {!props.eyShow && (
          <>
            <div className="datas">
              <p>Status:</p>
              <Label
                color={
                  props.status
                    ? "teal"
                    : props.status === null
                    ? "yellow"
                    : "red"
                }
                tag
              >
                {props.status
                  ? "Approved"
                  : props.status === null
                  ? "Pending"
                  : "Disapprove"}
              </Label>
            </div>
            <div className="event-btn-data">
              <div className="one">
                <Button circular icon color="blue" onClick={props.editEvent}>
                  <Icon name="edit" />
                </Button>
                {props.superAdmin && (
                  <Button
                    circular
                    icon
                    color="red"
                    onClick={() => props.deleteEvent(props.id)}
                  >
                    <Icon name="trash" />
                  </Button>
                )}
              </div>

              {props.superAdmin && (
                <div className="two">
                  <Dropdown
                    placeholder={
                      props.status
                        ? "Approved"
                        : props.status === null
                        ? "Pending"
                        : "Disapprove"
                    }
                    selection
                    onChange={(not, data) =>
                      handleApproval(data.value, props.id)
                    }
                    defaultValue={props.status}
                    options={[
                      {
                        key: 1,
                        text: "Approve",
                        value: true,
                        disabled: props.status,
                      },
                      {
                        key: 2,
                        text: "Pending",
                        value: null,
                        disabled: props.status === null ? true : false,
                      },
                      {
                        key: 3,
                        text: "Disapprove",
                        value: false,
                        disabled: props.status === false ? true : false,
                      },
                    ]}
                  />
                </div>
              )}
            </div>
          </>
        )}

        <div className="event-btn-data abs-btn only-one">
          {!props.auth.isEmpty && props.role !== "newUser" && (
            <>
              <Popup
                trigger={
                  <Button
                    circular
                    icon
                    basic={visitor ? true : false}
                    color="green"
                    onClick={() => handleAttend()}
                  >
                    <Icon name="user" />
                  </Button>
                }
                content={`Click Here To ${!visitor ? "Attend" : "Not Attend"}`}
                size="small"
              />
            </>
          )}
          <Popup
            trigger={
              <Link to={"/events/" + props.id} key={props.id} target="_blank">
                <Button circular icon="linkify" color="black" basic />
              </Link>
            }
            content={`Go To Events Detailed Information`}
            size="small"
          />
        </div>
      </div>

      <Modal
        size="tiny"
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
        open={open}
      >
        <Modal.Content scrolling className="eventVisitorModal">
          <div className="eventVisitorModalButton">
            <Button
              floated="left"
              circular
              icon="close"
              onClick={() => setOpen(false)}
            />
            {showListAdd ? (
              <div>
                {props.superAdmin && (
                  <Button
                    icon="plus"
                    floated="right"
                    circular
                    color="green"
                    onClick={() => setListAdd(!showListAdd)}
                  />
                )}
                <Popup
                  trigger={
                    <Button
                      icon
                      basic={visitor ? true : false}
                      disabled={props.auth.isEmpty || props.role === "newUser"}
                      circular
                      color="blue"
                      onClick={() => {
                        !props.auth.isEmpty && handleAttend();
                      }}
                    >
                      {props.attendant.length < 10 ? "0" : ""}
                      {props.attendant && props.attendant.length}
                    </Button>
                  }
                  content={`Click Here To ${
                    !visitor ? "Attend" : "Not Attend"
                  }`}
                  size="small"
                />
              </div>
            ) : (
              <div>
                {props.superAdmin && (
                  <Button
                    basic
                    icon="check"
                    circular
                    color="green"
                    onClick={() => {
                      if (newVisitors.length > 0) {
                        dispatch(handleAttenders(props.id, newVisitors));
                        setListAdd(true);
                      }
                    }}
                  />
                )}
                <Button
                  basic
                  icon="close"
                  floated="right"
                  circular
                  color="red"
                  onClick={() => setListAdd(true)}
                />
              </div>
            )}
          </div>

          {showListAdd ? (
            <div className="list">
              <Menu className="cu-tab" pointing secondary>
                <Menu.Item
                  name="Athletes"
                  active={!advocate}
                  onClick={() => {
                    showAdvocate(false);
                    setList(false);
                    setDefault(true);
                  }}
                />
                <Menu.Item
                  name="Advocate"
                  active={advocate}
                  onClick={() => showAdvocate(true)}
                />
              </Menu>
              {!advocate && (
                <div className="gridBoxDiv">
                  <Popup
                    content="Standard View"
                    trigger={
                      <Button
                        className={defaultView ? "primary" : ""}
                        onClick={() => {
                          setList(false);
                          setDefault(true);
                        }}
                      >
                        <Icon name="list ul" />
                      </Button>
                    }
                  />
                  <Popup
                    content="Detailed View"
                    trigger={
                      <Button
                        className={list ? "primary" : ""}
                        onClick={() => {
                          setList(true);
                          setDefault(false);
                        }}
                      >
                        <Icon name="server" />
                      </Button>
                    }
                  />
                </div>
              )}

              <VisitorList
                defaultView={defaultView}
                flag={advocate}
                listOne={
                  props.athAttendant.length > 0
                    ? props.athAttendant.sort((a, b) =>
                        a.name.toLowerCase() > b.name.toLowerCase()
                          ? 1
                          : b.name.toLowerCase() > a.name.toLowerCase()
                          ? -1
                          : 0
                      )
                    : props.athAttendant
                }
                listTwo={
                  props.advAttendant.length > 0
                    ? props.advAttendant.sort((a, b) =>
                        a.name.toLowerCase() > b.name.toLowerCase()
                          ? 1
                          : b.name.toLowerCase() > a.name.toLowerCase()
                          ? -1
                          : 0
                      )
                    : props.advAttendant
                }
                remove={handleRemoveVisitor}
                superAdmin={props.superAdmin}
              />
            </div>
          ) : (
            <>
              <AddVisitor
                visitorOptions={props.visitorOptions}
                visitors={props.visitors}
                getVisitors={(newVisitors) => {
                  setNewVisitors(newVisitors);
                }}
              />
            </>
          )}
        </Modal.Content>
      </Modal>
    </>
  );
};

const mapStateToProps = (state, ownProps) => {
  let advocateName;
  const athAttendant = [];
  const advAttendant = [];
  const newVisitorOptions = [];
  let uid;
  let role;
  let newUserKey;

  if (state.firestore.data.advocates && state.firestore.data.adminAthletes) {
    if (ownProps.advocate) {
      advocateName = state.firestore.data.advocates[ownProps.advocate].name;
    }
    const athKeys = Object.keys(state.firestore.data.adminAthletes);
    const advKeys = Object.keys(state.firestore.data.advocates);

    advKeys.forEach((key) => {
      newVisitorOptions.push({
        key,
        text: state.firestore.data.advocates[key].name,
        value: state.firestore.data.advocates[key].name,
      });
    });
    athKeys.forEach((key) => {
      newVisitorOptions.push({
        key,
        text: `${state.firestore.data.adminAthletes[key].firstName} ${state.firestore.data.adminAthletes[key].lastName}`,
        value: `${state.firestore.data.adminAthletes[key].firstName} ${state.firestore.data.adminAthletes[key].lastName}`,
      });
    });
  }
  const copyArray = JSON.parse(JSON.stringify(ownProps.attendant));
  copyArray.forEach((e) =>
    e.customUrl ? athAttendant.push(e) : advAttendant.push(e)
  );
  const attendantNames = copyArray.map((value) => value.name);
  const filteredOptions = newVisitorOptions.filter(
    (value) => !attendantNames.includes(value.text)
  );
  if (state.firebase.auth && state.firestore.data.userRole) {
    uid = state.firebase.auth.uid;
    const keys = Object.keys(state.firestore.data.userRole);
    keys.forEach((key) => {
      if (state.firestore.data.userRole[key].userUID === uid) {
        role = state.firestore.data.userRole[key].role;
        if (role === "newUser") {
          newUserKey = uid;
        }
      }
    });
  }
  return {
    newUserKey,
    role,

    loggedUser: state.firebase.auth.uid,
    superAdmin: state.auth.superAdmin,
    auth: state.firebase.auth,
    advocateName,
    athAttendant: athAttendant.filter((e) => Object.keys(e).length > 0),
    advAttendant: advAttendant.filter((e) => Object.keys(e).length > 0),
    visitorOptions: filteredOptions,
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect(() => [
    {
      collection: "adminAthletes",
    },
    {
      collection: "advocates",
    },
    {
      collection: "userRole",
    },
  ])
)(EventCard);
